module.exports = __webpack_public_path__ + "img/lang-select-bg2.ec01b5fe.png";